/*
  RK background-film boot.

  Background films ship from snippets/rk-bg-video.liquid with NO src and preload="none",
  naming their desktop and phone files in data attributes. This picks one and starts it.

  Why the markup carries no src: `autoplay` makes a browser begin fetching immediately,
  so a phone downloaded the 1920x1080 desktop master before any script could intervene,
  and then downloaded the portrait cut on top of it. Choosing here means exactly one file
  is ever fetched. The bespoke film's 9.5MB master is the reason this matters.

  Phone behaviour beyond the smaller file:
    - Save-Data or prefers-reduced-motion: nothing is fetched at all. The poster is the
      deliberate final state, which is the honest choice on a metered GCC/Lebanon plan.
    - Films play only while on screen, so a page with several loops does not decode all
      of them at once on a battery-limited device.

  The scroll-scrubbed bespoke film keeps its own path in rk-bespoke-film.js, where
  scrubbing is switched off entirely on touch.
*/
(function () {
  function mq(q) { return window.matchMedia && window.matchMedia(q).matches; }
  function isPhone() { return mq('(max-width: 749px)'); }
  function reduceMotion() { return mq('(prefers-reduced-motion: reduce)'); }
  function saveData() {
    var c = navigator.connection;
    return !!(c && c.saveData);
  }

  function boot(video) {
    if (video.dataset.rkBgReady === '1') return;
    video.dataset.rkBgReady = '1';

    var phone = isPhone();
    var mobileSrc = video.getAttribute('data-mobile-src');
    var mobilePoster = video.getAttribute('data-mobile-poster');

    if (phone && mobilePoster) video.setAttribute('poster', mobilePoster);

    /* Poster only: never fetch the film. */
    if (reduceMotion() || (phone && saveData())) return;

    var src = phone && mobileSrc ? mobileSrc : video.getAttribute('data-desktop-src');
    if (!src) return;

    /* Order matters on iOS: muted must be true BEFORE a source is attached, or Safari
       treats the element as unmuted and refuses inline autoplay. Setting the attribute
       as well as the property is the belt-and-braces form older iOS actually checks. */
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    /* Safe to set now, not in the markup: the element has no src until this line, so
       autoplay cannot start the double fetch this whole file exists to prevent. iOS
       gives a muted inline element with the autoplay attribute a much better chance
       than a bare scripted play() call. */
    video.autoplay = true;
    video.preload = 'metadata';
    video.src = src;

    /* iOS Low Power Mode blocks autoplay outright and rejects the play() promise, which
       used to be swallowed silently and left the poster up for good. A user gesture is
       always permitted, so fall back to starting on the first touch anywhere. */
    var armed = false;
    function armGesture() {
      if (armed) return;
      armed = true;
      var once = function () {
        document.removeEventListener('touchstart', once);
        document.removeEventListener('click', once);
        var r = video.play();
        if (r && r.catch) r.catch(function () {});
      };
      document.addEventListener('touchstart', once, { passive: true });
      document.addEventListener('click', once);
    }

    function play() {
      var p = video.play();
      if (p && p.catch) p.catch(armGesture);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) play();
          else video.pause();
        });
      }, { threshold: 0.1 }).observe(video);
    } else {
      play();
    }
  }

  function init(root) {
    (root || document).querySelectorAll('video[data-rk-bgvideo]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
